__webpack_require__.p = "/kyiv-scooters/";